import { Navigate } from 'react-router-dom';
import { Page, type DispatchedAction } from '@eo/shared';

import { useAppSelector } from '../../app/store';
import { AdminChrome } from './AdminChrome';
import { AdminContent } from './AdminContent';
import { adminController } from './controller';
import type { AdminState } from './types';

// The isAdmin gate is UX-only; the backend re-checks staff admin on every
// admin-scoped route.
export default function AdminOverviewPage() {
  const me = useAppSelector((s) => s.staff.me);
  if (!me?.isAdmin) return <Navigate to="/" replace />;

  return (
    <Page<AdminState> controller={adminController as never} header={() => <AdminChrome />}>
      {({ data, actions }) => (
        <AdminContent
          data={data}
          onCreateStaff={(payload) => actions.createStaff(payload) as Promise<DispatchedAction>}
          onUpdateStaff={(payload) => actions.updateStaff(payload) as Promise<DispatchedAction>}
          onCreateClient={(payload) => actions.createClient(payload) as Promise<DispatchedAction>}
          onUpdateClient={(payload) => actions.updateClient(payload) as Promise<DispatchedAction>}
          onSyncTaskTypes={() => actions.syncTaskTypes() as Promise<DispatchedAction>}
          onVerifyIntegrations={(payload) =>
            actions.verifyIntegrations(payload) as Promise<DispatchedAction>
          }
          onCreateHoliday={(payload) => actions.createHoliday(payload) as Promise<DispatchedAction>}
          onRemoveHoliday={(payload) => actions.removeHoliday(payload) as Promise<DispatchedAction>}
          onQueryOptions={(payload) => void actions.queryOptions(payload)}
        />
      )}
    </Page>
  );
}
